<template>
    <div class="AddGuideImgDia">
      <el-dialog title="设置引导图" :visible="dialogVisible" :close-on-click-modal="false" width="600px" @close="close">
        <el-form ref="formRef" :model="formData" :rules="formRule" label-width="110px">
          <el-form-item label="示例图图片" prop="imgList">
              <ElImgUploadGroup
                place-txt="提示：图片仅支持上传jpg/png/gif格式，建议尺寸：340-340px,最多上传3张。"
                :length="3"
                :exist-img-list="formData.imgList"
                @handleChange="handleUploadGroupChange($event)"
              />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click.native="close">取消</el-button>
          <el-button type="primary" :loading="confirmLoading" @click.native="confirm">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import _api from "@/utils/request";
  import ElImgUploadGroup from "@/components/global/components/elements/upload-group-element";
  export default {
    name: "AddGuideImgDia",
    components: { ElImgUploadGroup },
    props: {
      dialogVisible: {
        type: Boolean,
        default: false,
      },
      id: [String, Number],
    },
    data() {
      return {
        formData: {
          imgList: [],
        },
        formRule: {
          imgList: [{ required: true, message: '请上传图片', trigger: 'change' }],
        },
        confirmLoading: false
      };
    },
    created() {
      this.getGuideList()
    },
    methods: {
      close() {
        this.$emit('close')
      },
      getGuideList() {
        _api.getGuideList({id:this.id}).then(res => {
          if(res.data && res.data.length){
            this.formData.imgList = res.data.map(item => item.guideImage);
          }
        })
      },
      handleUploadGroupChange(list) {
        console.log(list,'++++++++++');
        this.formData.imgList = list;
      },
      confirm() {
        this.$refs['formRef'].validate((vaild) => {
          if (vaild) {
            this.confirmLoading = true
            let guideList = this.formData.imgList.map(item => {
              return {
                guideImage: item,
              }
            })
            _api.saveGuide({
              guideList,
              id: this.id,
            }).then(() => {
              this.$message.success('操作成功！')
              this.close()
            }).finally(() => {
              this.confirmLoading = false;
            });
          }
        })
      }
    }
  };
  </script>